import { Image, type ImageUnion } from "@/components/Image";
import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  image: ImageUnion;
  alt: string;
  square?: boolean;
};
export const ImageCard = ({ children, image, alt, square = false }: Props) => {
  return (
    <div className="relative w-full cursor-pointer group after:transition-opacity after:opacity-0 after:absolute after:inset-0 hover:after:opacity-100 after:rounded-xl after:-z-10 after:shadow-[0_2px_24px_0_#6D6662]">
      <Image
        className="bg-black rounded-xl"
        imgClassName="opacity-60 group-hover:opacity-50 transition group-hover:scale-105"
        image={image}
        alt={alt}
        sizes="440px"
        objectFit="cover"
        height={{
          type: "ratio",
          value: square ? 100 : 36,
        }}
      />
      {children}
    </div>
  );
};
